import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { axiosInstance } from './axios';

class GatepassOrderApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/wms/gatepassorder');
  }

  protected transformNode(node: any) {
    // Transform gatepass order data if needed
    return node;
  }

  // Custom methods for gatepass order specific operations
  async findByFacility(facilityId: string) {
    return axiosInstance.get(`${this.baseURL}/orders/facility/${facilityId}`);
  }

  async getGatepassOrderSummary(id: string) {
    return axiosInstance.get(`${this.baseURL}/${id}/summary`);
  }

  // Handle close action
  async close(sorters: any, filters: any, payload: any, query: any, headers: any, meta: any) {
    if (meta?.gatepassOrderId) {
      const response = await axiosInstance.post(
        `${this.baseURL}/${meta.gatepassOrderId}/close`,
        payload,
      );
      return response.data;
    }
    throw new Error('gatepassOrderId is required for close action');
  }

  // Handle link-gatepass action
  async 'link-gatepass'(
    sorters: any,
    filters: any,
    payload: any,
    query: any,
    headers: any,
    meta: any,
  ) {
    if (meta?.gatepassOrderId && (meta?.gatepassId || payload?.gatepassCode)) {
      // If gatepassId is provided, use the original endpoint
      if (meta?.gatepassId) {
        const response = await axiosInstance.post(
          `${this.baseURL}/${meta.gatepassOrderId}/link-gatepass/${meta.gatepassId}`,
        );
        return response.data;
      }
      // If gatepassCode is provided, use the new endpoint that accepts gatepass code
      if (payload?.gatepassCode) {
        const response = await axiosInstance.post(
          `${this.baseURL}/${meta.gatepassOrderId}/link-gatepass`,
          {
            gatepassCode: payload.gatepassCode,
          },
        );
        return response.data;
      }
    }
    throw new Error(
      'gatepassOrderId and either gatepassId or gatepassCode are required for link-gatepass action',
    );
  }

  // Handle unlinked-gatepasses action
  async 'unlinked-gatepasses'(
    sorters: any,
    filters: any,
    payload: any,
    query: any,
    headers: any,
    meta: any,
  ) {
    const response = await axiosInstance.get(`${this.baseURL}/unlinked-gatepasses`);
    return response.data;
  }

  // Handle mark-in-transit action
  async 'mark-in-transit'(
    sorters: any,
    filters: any,
    payload: any,
    query: any,
    headers: any,
    meta: any,
  ) {
    if (meta?.gatepassOrderId) {
      const response = await axiosInstance.post(
        `${this.baseURL}/${meta.gatepassOrderId}/mark-in-transit`,
        payload,
      );
      return response.data;
    }
    throw new Error('gatepassOrderId is required for mark-in-transit action');
  }
}

export default GatepassOrderApiClient;
